import styled from 'styled-components'

import { helpers } from '../../styles/theme'

type Props = {
	maxWidth?: number
}

export const Bubble = styled.div<Props>`
	padding: 10px 18px;
	max-width: ${({ maxWidth = 350 }) => maxWidth}px;
	width: max-content;
	box-shadow: 0 0 24px rgba(0, 0, 0, 0.175);
	text-align: center;
	white-space: pre-wrap;
	font-size: 1rem;
	background-color: ${helpers.color.background};
	border-radius: 4px;
`
